import { render, staticRenderFns } from "./chevrons-right.vue?vue&type=template&id=eb679bb4"
import script from "./chevrons-right.vue?vue&type=script&lang=js"
export * from "./chevrons-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports